  <template>
  		<!-- Header -->
		<div class="animated fadeIn">     
		           
		       <b-breadcrumb>
		          <div class="col-md-8">
					<a href="#/" class="c-sidebar-brand d-md-down-none router-link-active" target="_self"><img src="https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.png"></a>
				  </div>	
		          <div class="col-md-4">-</div>	

		       </b-breadcrumb>

		        <div class="col-md-12"><h3>Sample Designs</h3></div>	
		        <div class="col-md-12">
		        	

					<div class="card">
					   <div class="card-body">
					      <div v-for="designs in design_list" class="col-md-3 " style="float: left; margin-bottom: 15px;">
					         <div class="card-deck">
					            <div class="card">
					               <!----><!---->
					               <div class="card-body">
					                  <!----><!---->
					                  <p class="card-text">
					                  <div style="width: 100%; float: left; margin-bottom: 15px;">
					                     <div style="float: left;"><img src="img/avatars/13.jpg" class="c-avatar-img"></div>
					                  </div>
					                  </p>
					               </div>
					               <div class="card-footer">
					                 
					                      	<span style="float:left">
					                      		{{designs.design_title}}
					                      	</span>	
											<span style="float:right">
											  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
											    <template v-slot:button-content>
											      <span class="cui-options icons font-1xl d-block"></span>
											    </template>
											    <b-dropdown-item 
                          :href="'/designdetail/' + designs.design_id"
                          >View Detail</b-dropdown-item>
											    <b-dropdown-item href="#">Send Quote</b-dropdown-item>
											    
											  </b-dropdown>
											</span>													 
					                
					               </div>
					               <!---->
					            </div>
					         </div>
					      </div>
					      
					     
					     
					   </div>
					</div>

		        </div>

        </div> 

  </template>

<style>
.c-avatar-img {
    width: 100%;
    height: auto;
    border-radius: 50em;
}	
.card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.0rem;
}
</style>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')


export default {
  name: 'Cards',
  data: function () {
    return {
      sampelAddModal: false,
     
      show: true,
      isCollapsed: true,
      design_list:[],
      collection_title:''
      
    }
  },
  created: function() {  
    this.getDesignSampleList();
    
   
  },

  methods: {      

    /****** Function to Get Design Sample List ********/
    getDesignSampleList: function () {

        this.isBusy = true;

       
        axios.post(`${CONSTANTS.API_URL}/getdesignsamplelist`,{})
        .then(response => {
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.design_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            
            this.isBusy = !this.isBusy;
            
          }else {
           this.design_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


    },


     /****** Function to Add Collection ********/
    collectionForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const collectionObj = {
            collection_title: this.collection_title
           
          }
            
          if (this.collection_title !== '' ) {
            axios.post(`${CONSTANTS.API_URL}/addnewcollections`,collectionObj)
            .then(response => {
                if(response.data.returnmsg == 'Successful') {

                    // alert("New Collection Added Successfully.");
                    this.$fire({
                 text:"New Collection Added Successfully.",
                 type: "success",
                 timer: 30000
                        })
                    window.location.href ="collections";
                } else {
                  if (result.body.returnmsg === 'NoUserExists') {
                
                    this.showAlert=true
                    
                  }
                }
              })
          }
        }
      })
    },


  }


}
</script>
